// Credits https://github.com/thanhlmm/next-lazy-hydrate
import dynamic from 'next/dynamic'
import withHydrationOnDemand from './with-hydration-on-demand'

const EmptyComp = () => null

export default function dynamicHydrate(
	module,
	{ on = [['visible', () => ({ rootMargin: '80px' })]], loading = EmptyComp, wrapperProps } = {}
) {
	return withHydrationOnDemand({
		on,
		onBefore: module, // Make sure we load component before hydrating it
		wrapperProps,
	})(
		dynamic(module, {
			loading,
			ssr: true,
		})
	)
}
